<template>
  <nav
    ref="navbar"
    :class="[$style.container, { [$style.scrolled]: isPageScrolled }]"
    data-luko-tracking="PartnershipNavbar"
  >
    <Wrapper :class="$style.inner">
      <PImage
        v-if="primary.partner_logo && primary.partner_logo.url"
        :image-object="primary.partner_logo"
        :class="$style.logo"
        sizes="xs:100px"
      />
      <div
        v-if="primary.partner_logo && primary.partner_logo.url"
        :class="$style.seperator"
      />
      <PImage
        v-if="primary.luko_logo && primary.luko_logo.url"
        :image-object="primary.luko_logo"
        :class="$style.logo"
        sizes="xs:100px"
      />
      <RichText
        v-if="primary.luko_description && primary.luko_description.length"
        :text-params="primary.luko_description"
        :class="$style.description"
      />
    </Wrapper>
  </nav>
</template>

<script>
import RichText from '~/components/RichText'

export default {
  name: 'SliceName',
  components: {
    RichText,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      primary: this.slice.primary,
      hasShadow: false,
    }
  },
  computed: {
    isPageScrolled() {
      return this.$store.state.header.fixedHeader
    },
  },
}
</script>

<style lang="scss" module>
@keyframes slide-down {
  0% {
    transform: translateY(-60px);
  }
  100% {
    transform: translateY(0);
  }
}

.container {
  position: relative;
  z-index: 5;

  width: 100%;
  height: 64px;
  padding: 0 24px;

  background-color: white;
}
.scrolled {
  position: fixed !important;
  top: 0;

  box-shadow: 0 2px 16px $gray-400;

  animation: slide-down 0.3s ease-in-out;
}

.inner {
  display: flex;
  align-items: center;
  width: 1280px;
  height: 100%;
}
.logo {
  min-width: 40px;
  height: 35px;
}
.seperator {
  z-index: 5;

  width: 1px;
  height: 25px;
  margin: 0 32px 0 28px;
  border: 1px solid #c4c4c4;
}
.description {
  margin-left: 9px;

  color: $bluko-900;
  font-size: 12px;

  p {
    line-height: 15px;
  }
}
</style>
